module.exports = __webpack_public_path__ + "img/product-plsc-two.3d1f894.png";